import { GeoPoint } from '@core/const';
import { Action } from '@ngrx/store';

export const USER_GEO_POINT_UPDATE = '[CustomUser] GeoPoint Update';

export class UserGeoPointUpdate implements Action {
  readonly type = USER_GEO_POINT_UPDATE;

  constructor(public payload: GeoPoint) {}
}

// action types
export type UserGeoPointAction = UserGeoPointUpdate;
